export const multiPageCollectionSlug = 'Multipage collection' // Magic string, the collection name is set in the CMS.
export const articleListingCollectionSlug = 'Article listing'
export const articleCollectionCardSlug = 'Article collection card'
export const featuredArticleCardSlug = 'Featured articles card'
export const superCategoryCollectionSlug = 'Super category collection'
export const verticalAdviceCollectionSlug = 'Vertical advice collection'
export const verticalArticleCardRowSlug = 'vertical article card row'
